import { atom } from 'recoil';

export const LinechartCaching = atom({
  key: 'LinechartCaching',
  default: {},
});

export const CandlestickCaching = atom({
  key: 'CandlestickCaching',
  default: {},
});

export const PerformanceCaching = atom({
  key: 'PerformanceCaching',
  default: {},
});

export const AboutCaching = atom({
  key: 'AboutCaching',
  default: {},
});
